module.exports = __webpack_public_path__ + "static/media/garnett.7647567d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Login/images/garnett.svg
// module id = 362
// module chunks = 9